<template>
  <div class="orm-locationMap__stationsList__container overflowHidden">
    <div class="orm-locationMap__stationsList orm-stationsList">
      <div
        v-for="station in stations"
        :key="station.id"
        class="orm-stationsList__station orm-relative"
        :class="[
          store.getters['userSession/GET_STATION'] == station.id
            ? 'selected'
            : '',
          'orm-stationsList__station-' + station.id,
        ]"
        @click="
          store.getters['userSession/GET_STATION'] == station.id
            ? false
            : setStation(station.id)
        "
      >
        <div v-if="store.getters['userSession/GET_STATION'] == station.id">
          <div class="orm-station__container orm-row">
            <div class="orm-station__title orm-col-xs-12">
              <p>{{ i18n("general/station") }}</p>
              <!-- <div
                class="orm-station__distance"
                v-if="userSession.userLocation"
              >
                <small
                  >{{
                    getDistanceFromLatLonInKm(
                      station.latitude,
                      station.longitude,
                      userSession.userLocation
                    )
                  }}
                  {{ i18n("general/metric") }}</small
                >
              </div> -->
              <span class="orm-station__icons">
                <i
                  v-if="station.is_rent_station"
                  class="fas fa-car orm-car__rental"
                ></i>
                <i
                  v-if="station.is_sharing_station"
                  class="fas fa-car orm-car__share"
                ></i>
                <i
                  v-if="station.is_special"
                  class="fas fa-car orm-car__special"
                ></i>
                <i
                  v-if="
                    !station.is_sharing_station &&
                      !station.is_special &&
                      !station.is_rent_station
                  "
                  class="fas fa-car orm-car__abo"
                ></i>
              </span>
            </div>
            <div class="orm-col-xs-12">
              <stationpicker :data="stations" type="start" :readonly="true" />
              <stationpicker
                :data="stationsEnd"
                type="end"
                viewType="mapModule"
                v-if="
                  store.getters['ORMgeneral/GET_PARAMETER'](
                    'BINET_ALLOW_ONEWAY'
                  ) == 1 && station.is_auto_abo_station != true
                "
              />
            </div>
          </div>

          <datepicker
            viewType="mapModule"
            vDatepickerTeleport="#v-range-selector-map"
            v-if="station.is_auto_abo_station != true"
          />
          <datepicker_abo
            viewType="mapModule"
            vDatepickerTeleport="#v-range-selector-map"
            v-else
          />
          <div
            class="orm-relative orm-mb-8"
            v-if="store.getters['ORMgeneral/GET_PARAMETER'](
                        'BORM_PRESELECT_PLANNED_KM'
                      ) === '1' && station.is_auto_abo_station != true"
          >
            <div class="orm-searchbar__headline">
              {{ i18n("general/plannedDistance") || "Geplante Kilometer" }}
            </div>
            <KmInput />
          </div>
          <div class="orm-row">
            <div class="orm-col-xs-12">
              <div class="orm-stationsList__button">
                <button
                  v-if="!loading"
                  @click="getCars('/reservation/step1')"
                  class="orm-button__cta orm-btn__block"
                  :class="[station ? '' : 'disable']"
                >
                  {{ i18n("general/showOffers") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="orm-station__container">
            <div class="orm-station__name__container">
              <span class="orm-station__name">
                {{ station.name }}
              </span>
              <div
                class="orm-station__distance"
                v-if="userSession.userLocation"
              >
                <small
                  >{{
                    getDistanceFromLatLonInKm(
                      station.latitude,
                      station.longitude,
                      userSession.userLocation
                    )
                  }}
                  km</small
                >
              </div>
              <span class="orm-station__icons">
                <i
                  v-if="station.is_rent_station"
                  class="fas fa-car orm-car__rental"
                ></i>
                <i
                  v-if="station.is_sharing_station"
                  class="fas fa-car orm-car__share"
                ></i>
                <i
                  v-if="station.is_special"
                  class="fas fa-car orm-car__special"
                ></i>
                <i
                  v-if="
                    !station.is_sharing_station &&
                      !station.is_special &&
                      !station.is_rent_station
                  "
                  class="fas fa-car orm-car__abo"
                ></i>
              </span>
            </div>

            <div class="orm-station__street">
              {{ station.street }}, {{ station.city }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import { getDistanceFromLatLonInKm } from "@/constants/formater";

import stationpicker from "@/components/ui/stationpicker.vue"; // @ is an alias to /src
import datepicker from "@/components/ui/datepicker.vue"; // @ is an alias to /src
import datepicker_abo from "@/components/ui/datepicker_abo.vue"; // @ is an alias to /src
import store from "@/store";
import i18n from "@/mixins/mixins";
import KmInput from "@/components/ui/km-input.vue";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "stationlist",
  components: { datepicker, datepicker_abo, stationpicker, KmInput },
  mixins: [i18n],
  props: {
    stationtype: {
      default: "ALL",
      required: false,
    },
  },
  setup() {
    const userSession = store.state.userSession.LocalSession;
    // console.log("stations", stations);
    const env = process.env;
    return {
      getDistanceFromLatLonInKm,
      userSession,
      store,
      env,
    };
  },
  data() {
    return {
      stations: Object,
      stationsEnd: Object,
      loading: false,
      watch: false,
    };
  },
  async mounted() {
    const sorted = await store.getters["stations/GET_STATIONS_SORTED"];
    this.stations = sorted[this.stationtype];
    this.stationsEnd = sorted[store.getters["userSession/GET_STATIONTYPE"]];
    // console.log(this.stationsEnd);
    this.watch = true;
    this.scrollList();

    store.watch(
      // eslint-disable-next-line
      (state, getters) =>
        getters["stations/GET_STATIONS_SORTED"][this.stationtype],
      () => {
        this.stations =
          store.getters["stations/GET_STATIONS_SORTED"][this.stationtype];
        this.scrollList();
      },
      { immediate: true }
    );

    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["userSession/GET_STATIONTYPE"],
      (val) => {
        this.stationsEnd = sorted[val];
      }
    );

    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["userSession/GET_STATION"],
      () => {
        this.scrollList();
      },
      { immediate: true }
    );
  },
  unmounted() {
    this.watch = false;
  },
  methods: {
    setStation(station) {
      store.dispatch("userSession/SET_STATION", station);
      store.dispatch("userSession/SET_STATION_END", "startend");
      this.scrollList();
    },
    async scrollList() {
      const newstation = await store.getters["userSession/GET_STATION"];

      const element = document.querySelectorAll(
        ".orm-stationsList__station-" + newstation
      );
      if (element.length == 0) return;
      const innerEL = this.$el.children[0];
      // console.log(element);
      // console.log(newstation);
      if (element && this.watch) {
        setTimeout(() => {
          innerEL.scrollTo({
            top: element[0].offsetTop - innerEL.offsetTop,
            behavior: "smooth",
          });
        }, 150);
      }
    },
    async getCars() {
      const times = await store.getters["stations/GET_OPENINGTIMES"];
      if (times) {
        this.loading = true;
        buildDataLayer("orm_reservation_begin", {}, "locationmap");
        routeToSteps(this, 1);
      }
    },
  },
});
</script>
